import { render } from "./Collapse.vue?vue&type=template&id=e771ffc2"
import script from "./Collapse.vue?vue&type=script&lang=ts"
export * from "./Collapse.vue?vue&type=script&lang=ts"

import "./Collapse.vue?vue&type=style&index=0&id=e771ffc2&lang=css"
script.render = render

export default script